import { themes } from 'constants/categoriesColors'

const getColors = (id) => (themes[id]);

const hasLowerCase = (str) => {
    return (/[a-z]/.test(str));
}

const capitalize = (str, lower) => {
    return (lower ? str.toLowerCase() : str).replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
}

export {getColors, hasLowerCase, capitalize};
